<template>
    <v-dialog class="ml-auto d-inline"
              v-model="dialog"
              width="500">
        <template v-if="!date"
                  v-slot:activator="{ on, attrs }">
            <span class="label-badge text-uppercase font-p2"
                  :class="classes"
                  v-bind="attrs"
                  v-on="on">
                {{ title }}
                <v-icon size="14">mdi-information-outline</v-icon>
            </span>
        </template>
        <template v-else
                  v-slot:activator="{ on, attrs }">
            <span class="label-badge text-uppercase"
                  :class="classes">
                {{ title }}
            </span>
        </template>
        <pane v-if="theme"
              :variant="theme.secondary"
              class="font-p1">
            <pane :variant="theme.primary"
                  padding="modal-head">
                <div class="d-flex">
                    <span class="pt-3 pl-6 pb-3 font-weight-bold align-self-center text-uppercase">
                        {{ title }}
                    </span>
                    <v-btn @click="dialog = false"
                           class="ml-auto mt-auto mb-auto mr-2"
                           icon
                           color="white">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>
            </pane>
            <pane class="pa-6"
                  :variant="theme.secondary"
                  v-if="theme && contents && contents[from] && contents[from][step] && contents[from][step][state]">
                <p v-for="content in contents[from][step][state]"
                   v-html="parseContent(content)"></p>
            </pane>
        </pane>
    </v-dialog>
</template>
<script>
import Pane from './Pane';

export default {
    name: 'LabelBadge',
    components: {
        Pane,
    },
    props: {
        title: {},
        date: {},
        from: {},
        state: {},
        step: {},
    },
    data() {
        return {
            dialog: false,
        };
    },
    methods: {
        parseContent(content) {
            switch (content) {
                case 'states.down':
                    content = `<span class="label-badge label-badge--example label-badge--down">${this.$vuetify.lang.t(`$vuetify.rank.states.in_progress`)}</span>`;
                    break;

                case 'states.in_progress':
                    content = `<span class="label-badge label-badge--example label-badge--in_progress">${this.$vuetify.lang.t(`$vuetify.rank.${content}`)}</span>`;
                    break;

                case 'states.rank_saved':
                    content = `<span class="label-badge label-badge--example label-badge--rank_saved">${this.$vuetify.lang.t(`$vuetify.rank.${content}`)}</span>`;
                    break;

                case 'states.succeeded':
                    content = `<span class="label-badge label-badge--example label-badge--succeeded">${this.$vuetify.lang.t(`$vuetify.rank.${content}`)}</span>`;
                    break;

                default:
                    content = `${this.$vuetify.lang.t(`$vuetify.rank.${content}`)}`;
                    break;
            }
            return content;
        },
    },
    computed: {
        contents() {
            return {
                member: {
                    1: {
                        in_progress: [
                            'label_intro_rank_raise',
                            'label_intro_october',
                            'your_possible_state_october',
                            'states.succeeded',
                            'example.succeeded',
                            'states.down',
                            'example.in_progress',
                            'why_october',
                            'thats_why_october',
                        ],
                        succeeded: [
                            'succeeded',
                            'example.succeeded4',
                        ],
                        down: [
                            'example.too_bad',
                        ],
                    },
                },
                superior_master: {
                    1: {
                        in_progress: [
                            'label_intro_rank_raise',
                            'label_intro_october',
                            'your_possible_state_october',
                            'states.rank_saved',
                            'example.rank_saved',
                            'states.down',
                            'example.in_progress2',
                            'states.succeeded',
                            'example.succeeded2',
                            'step_repetition',
                            'example.downgrade',
                            'why_october2',
                            'thats_why_october',
                        ],
                        rank_saved: [
                            'states.rank_saved',
                            'example.rank_saved2',
                            'example.rank_saved_additional',
                        ],
                        succeeded: [
                            'states.succeeded',
                            'succeeded',
                            'example.succeeded5',
                        ],
                        down: [
                            'example.too_bad2',
                        ],
                    },
                    2: {
                        in_progress: [
                            'label_intro_rank_raise',
                            'label_intro_october',
                            'your_possible_state_october',
                            'states.rank_saved',
                            'example.rank_saved',
                            'states.down',
                            'example.in_progress2',
                            'states.succeeded',
                            'example.succeeded',
                            'downgrade',
                            'example.downgrade',
                            'why_october2',
                            'thats_why_october',
                        ],
                        rank_saved: [
                            'states.rank_saved',
                            'example.rank_saved2',
                            'example.rank_saved_additional2',
                        ],
                        succeeded: [
                            'states.succeeded',
                            'succeeded',
                            'example.succeeded7',
                        ],
                        down: [
                            'example.too_bad2',
                        ],
                    },
                },
                legend_master: {
                    1: {
                        in_progress: [
                            'label_intro_rank_raise',
                            'label_intro_october',
                            'your_possible_state_october',
                            'states.rank_saved',
                            'example.rank_saved',
                            'states.down',
                            'example.in_progress2',
                            'states.succeeded',
                            'example.succeeded2',
                            'step_repetition',
                            'example.downgrade',
                            'why_october2',
                            'thats_why_october',
                        ],
                        rank_saved: [
                            'states.rank_saved',
                            'example.rank_saved2',
                            'example.rank_saved_additional',
                        ],
                        succeeded: [
                            'states.succeeded',
                            'succeeded',
                            'example.succeeded5',
                        ],
                        down: [
                            'example.too_bad2',
                        ],
                    },
                    2: {
                        in_progress: [
                            'label_intro_rank_raise',
                            'label_intro_october',
                            'your_possible_state_october',
                            'states.rank_saved',
                            'example.rank_saved',
                            'states.down',
                            'example.in_progress2',
                            'states.succeeded',
                            'example.succeeded',
                            'downgrade',
                            'example.downgrade',
                            'why_october2',
                            'thats_why_october',
                        ],
                        rank_saved: [
                            'states.rank_saved',
                            'example.rank_saved2',
                            'example.rank_saved_additional2',
                        ],
                        succeeded: [
                            'states.succeeded',
                            'succeeded',
                            'example.succeeded7',
                        ],
                        down: [
                            'example.too_bad2',
                        ],
                    },
                },
                ultimate_master: {
                    1: {
                        in_progress: [
                            'label_intro_rank_preservation',
                            'label_intro_october',
                            'your_possible_state_october',
                            'states.down',
                            'example.in_progress2',
                            'states.succeeded',
                            'example.succeeded6',
                            'why_october2',
                            'thats_why_october',
                        ],
                        succeeded: [
                            'states.succeeded',
                            'example.succeeded6',
                        ],
                        rank_saved: [
                            'states.succeeded',
                            'example.succeeded6',
                        ],
                        down: [
                            'example.too_bad3',
                        ],
                    },
                },
            };
        },
        theme() {
            const themes = {
                succeeded: {
                    primary: 'success',
                    secondary: 'success-darken',
                },
                in_progress: {
                    primary: 'in-progress',
                    secondary: 'in-progress-darken',
                },
                rank_saved: {
                    primary: 'rank-saved',
                    secondary: 'rank-saved-darken',
                },
                down: {
                    primary: 'down',
                    secondary: 'down-darken',
                },
            };

            let state = this.state;

            if (state === 'rank_saved' && this.from === 'ultimate_master') {
                state = 'succeeded';
            }

            return themes[state];
        },
        classes() {
            return {
                ['label-badge--succeeded']: this.state === 'succeeded' || (this.state === 'rank_saved' && this.from === 'ultimate_master'),
                ['label-badge--in_progress']: this.state === 'in_progress',
                ['label-badge--rank_saved']: this.state === 'rank_saved' && this.from !== 'ultimate_master',
                ['label-badge--down']: this.state === 'down',
            };
        },
    },
};
</script>